import { Button, GradientText, Title } from "lola-framework-ui-test";
import { useTranslation } from "react-i18next";
import { BodyCopy } from "../BodyCopy";
import { Popup } from "../Popup";
import { useStore } from "../../store/globalState";
import type { SmsConsentData } from "../../services/api";
import { smsConsentIntro } from "./smsConsentIntro";
import "./SmsConsentPopup.css";

/**
 * Opt-in for text messages. No close and no outside click: the user answers
 * Accept or Not now. The policy link opens the full policy page.
 */
export function SmsConsentPopup({
  consent,
  busy,
  onAccept,
  onDecline,
  onViewPolicy,
}: {
  consent: SmsConsentData;
  busy: boolean;
  onAccept: () => void;
  onDecline: () => void;
  onViewPolicy: () => void;
}) {
  const { t } = useTranslation();
  const { title, bodyCopy, background, backgroundBtn, textColorBtn } =
    useStore().theme.whiteView;
  const intro = smsConsentIntro(
    consent,
    t("smsConsent.intro", { phone: consent.maskedPhone ?? "" }),
  );

  return (
    <Popup
      visible
      showClose={false}
      dismissOnOutsideClick={false}
      onClose={() => undefined}
    >
      <section className="cancel-confirm-slot sms-terms-popup">
        <Title title={t("smsConsent.title")} align="center" color={bodyCopy} />
        <BodyCopy textColor={bodyCopy}>{intro}</BodyCopy>
        <div className="sms-terms-detail-row">
          <GradientText
            as="button"
            className="link sms-terms-detail-link"
            textColor={title}
            onClick={onViewPolicy}
          >
            {t("smsConsent.viewPolicy")}
          </GradientText>
        </div>
        <div className="cancel-confirm-actions">
          <Button
            type="button"
            size="large"
            variant="outline"
            background={backgroundBtn}
            color={bodyCopy}
            style={{ backgroundColor: background }}
            disabled={busy}
            onClick={onDecline}
          >
            {t("smsConsent.decline")}
          </Button>
          <Button
            size="large"
            background={backgroundBtn}
            color={textColorBtn}
            disabled={busy}
            onClick={onAccept}
          >
            {t("smsConsent.accept")}
          </Button>
        </div>
      </section>
    </Popup>
  );
}
